import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
export function CheckboxFormFieldRow(_ref) {
  let {
    fieldName,
    label,
    checked,
    value,
    onChange,
    disabled = false,
    dataTestId = '',
    labelPlacement = 'left'
  } = _ref;
  const {
    t
  } = useTranslation();
  const isLabelLeft = labelPlacement === 'left';
  const translatedLabel = t("".concat(label || fieldName));
  const dataTestIdValue = dataTestId || fieldName;
  return /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, isLabelLeft && /*#__PURE__*/React.createElement(Form.Label, {
    column: true,
    md: 3,
    htmlFor: fieldName
  }, translatedLabel), /*#__PURE__*/React.createElement(Col, {
    md: isLabelLeft ? {
      span: 9
    } : undefined
  }, /*#__PURE__*/React.createElement(Form.Check, {
    type: "checkbox",
    "data-testid": dataTestIdValue,
    id: fieldName,
    label: !isLabelLeft ? translatedLabel : undefined,
    name: fieldName,
    checked: checked || value,
    value: value,
    onChange: onChange,
    disabled: disabled
  })));
}